import {Component} from '@angular/core';
import {AboutUsComponent} from "../../../layout/legal/about-us/about-us.component";
import {SrsDisclaimerComponent} from "../../../layout/legal/srs-disclaimer/srs-disclaimer.component";
import {TermsOfUseComponent} from "../../../layout/legal/terms-of-use/terms-of-use.component";
import {ContactUsComponent} from "../../../layout/legal/contact-us/contact-us.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss']
})
export class MainFooterComponent {

  constructor(private dialog: MatDialog) {
  }

  openAboutUs(): void {
    this.dialog.open(AboutUsComponent);
  }

  openDisclaimer(): void {
    this.dialog.open(SrsDisclaimerComponent, {
      height: '450px',
      width: '900px'
    });
  }

  openTermsOfUse(): void {
    this.dialog.open(TermsOfUseComponent);
  }

  openContactUs(): void {
    this.dialog.open(ContactUsComponent, {
      height: '450px',
      width: '560px'
    });
  }
}
